export const MAX_LIBRARY_SCREENSHOTS = 5;
export const LIBRARY_SCREENSHOT_MAX_WIDTH = 720;
export const LIBRARY_SCREENSHOT_MAX_HEIGHT = 4096;
export const LIBRARY_SCREENSHOT_JPEG_QUALITY = 0.84;

export const getBoundedImageDimensions = (
    width,
    height,
    maxWidth = LIBRARY_SCREENSHOT_MAX_WIDTH,
    maxHeight = LIBRARY_SCREENSHOT_MAX_HEIGHT,
) => {
    if (
        !Number.isFinite(width) ||
        !Number.isFinite(height) ||
        width <= 0 ||
        height <= 0 ||
        !Number.isFinite(maxWidth) ||
        !Number.isFinite(maxHeight) ||
        maxWidth <= 0 ||
        maxHeight <= 0
    ) {
        throw new Error('Could not read this screenshot.');
    }

    const scale = Math.min(1, maxWidth / width, maxHeight / height);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
};

const loadImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Could not read this screenshot.'));
    image.src = url;
});

const canvasToJpegBlob = (canvas, quality) => new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
        if (blob) {
            resolve(blob);
        } else {
            reject(new Error('Could not prepare this screenshot.'));
        }
    }, 'image/jpeg', quality);
});

export const convertImageFileToJpeg = async (
    file,
    {
        maxWidth = LIBRARY_SCREENSHOT_MAX_WIDTH,
        maxHeight = LIBRARY_SCREENSHOT_MAX_HEIGHT,
        quality = LIBRARY_SCREENSHOT_JPEG_QUALITY,
    } = {},
) => {
    if (!file || typeof file.type !== 'string' || !file.type.startsWith('image/')) {
        throw new Error('Choose an image screenshot.');
    }

    const objectUrl = URL.createObjectURL(file);
    try {
        const image = await loadImage(objectUrl);
        const sourceWidth = image.naturalWidth || image.width;
        const sourceHeight = image.naturalHeight || image.height;
        const dimensions = getBoundedImageDimensions(
            sourceWidth,
            sourceHeight,
            maxWidth,
            maxHeight,
        );
        const canvas = document.createElement('canvas');
        canvas.width = dimensions.width;
        canvas.height = dimensions.height;

        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('Could not prepare this screenshot.');
        }

        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        return canvasToJpegBlob(canvas, quality);
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
};

export const jpegFilenameFor = (filename, index = 0) => {
    const baseName = typeof filename === 'string'
        ? filename.replace(/\.[^/.]+$/, '').trim()
        : '';
    return `${baseName || `library-screenshot-${index + 1}`}.jpg`;
};
